
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa",
      function () {
        return require("private-next-pages/sa/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa"])
      });
    }
  